import { projectPriorityParam, type PROJECT_PRIORITY_FILTER_OPTIONS } from '@/lib/project-priority'
import { serviceTierParam, type SERVICE_TIER_FILTER_OPTIONS } from '@/lib/service-tier'

export const AUTOMATION_OPTIONS = ['all', 'enabled', 'disabled'] as const
export const SOURCE_OPTIONS = ['all', 'shopify', 'dropship'] as const

export interface ProjectFilterValues {
  status: string
  stage: string | null
  automation: (typeof AUTOMATION_OPTIONS)[number]
  source: (typeof SOURCE_OPTIONS)[number]
  priority: (typeof PROJECT_PRIORITY_FILTER_OPTIONS)[number]
  tier: (typeof SERVICE_TIER_FILTER_OPTIONS)[number]
  staff: number | null
}

/** How many filters are set away from their defaults, for the Filters button; `defaultStatus` is the page's own. */
export function activeProjectFilters(values: ProjectFilterValues, defaultStatus: string, staffLocked: boolean) {
  return [
    (values.stage ?? values.status) !== defaultStatus,
    values.automation !== 'all',
    values.source !== 'all',
    values.priority !== 'all',
    values.tier !== 'all',
    !staffLocked && values.staff != null,
  ].filter(Boolean).length
}

/** The projects list's query for these filters; staff is left to the caller, which may lock it to My Projects. */
export function projectFilterParams(values: ProjectFilterValues) {
  return {
    status: values.status === 'all' ? undefined : values.status,
    stage: values.stage ?? undefined,
    tracking_enabled: values.automation === 'all' ? undefined : values.automation === 'enabled',
    source_type: values.source === 'all' ? undefined : values.source,
    priority: projectPriorityParam(values.priority),
    service_tier: serviceTierParam(values.tier),
  }
}
